import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { TopEventsEventForm } from './topEventsForm/TopEventsForm';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { ListHeader } from 'src/domains/layouts/shared/cms/list/listHeader/ListHeader';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { ListWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { TopEventsEventsList } from './topEventsList/TopEventsEventsList';
import { BulkDeleteDialogState } from 'src/main/cms/PromotedEvents/bulkDeleteDialog/bulkDeleteDialogState';
import { Button } from 'src/domains/common/components/button/button';
import { BulkDeleteDialog } from 'src/main/cms/PromotedEvents/bulkDeleteDialog/bulkDeleteDialog';
import { DialogGeneric } from 'src/domains/common/components/dialog/DialogGeneric';

export const TopEvents = observer('TopEvents', () => {
    const {
        cmsState: { topEventsState },
        trpcClient,
        sdkStaff,
    } = useAppStateContext();

    const isLoading = topEventsState.isTopEventsEventsDataLoading;
    const [bulkDeleteDialogState] = useState(
        () =>
            new BulkDeleteDialogState(
                sdkStaff.models,
                trpcClient.client.topEventsEvents.bulkDeleteTopEventsEvents.mutate,
                topEventsState.topEventsEventsResource
            )
    );

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListWrapper>
                        <ListHeader label='Top Events'>
                            <>
                                Events will appear on the homepage under the <b>Top Events</b> section. The order of the
                                events is how it appears on the live site. You can change the order using the drag icon
                                below.
                                <b> For horse and greyhound racing, only outrights and antepost events can be added.</b>
                            </>
                        </ListHeader>
                        {isLoading || topEventsState.topEventsEventsData === null ? (
                            <Loader isActive={isLoading} />
                        ) : (
                            <>
                                <Button
                                    onClick={bulkDeleteDialogState.openDialog}
                                    variant='destructive'
                                    icon='trash'
                                    className='mb-4'
                                >
                                    Bulk Delete
                                </Button>
                                <TopEventsEventsList />
                            </>
                        )}
                    </ListWrapper>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <TopEventsEventForm onCreate={async () => await topEventsState.topEventsEventsResource.refresh()} />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
            {bulkDeleteDialogState.isOpen === true && <BulkDeleteDialog state={bulkDeleteDialogState} />}
            {bulkDeleteDialogState.isSuccessDialogOpen && (
                <DialogGeneric
                    title='Success'
                    message={<p>Successfully deleted selected events.</p>}
                    onConfirm={bulkDeleteDialogState.hideSuccessDialog}
                    confirm_label='Continue'
                />
            )}
            {bulkDeleteDialogState.isErrorDialogOpen && (
                <DialogGeneric
                    title='Error'
                    message={<p>Could not delete selected events. Please try again.</p>}
                    onConfirm={bulkDeleteDialogState.hideErrorDialog}
                    confirm_label='Continue'
                />
            )}
        </MainContent>
    );
});
